import { FC } from "react";
import Image from "next/image";
import dayjs from "dayjs";
import Card from "@/components/Card";
import Typography from "@/components/Typography";
import Grid from "@/components/Grid";
import { MiniTable } from "@/components/DataTable";
import Divider from "@/components/Divider";
import { RedirectIcon } from "@/components/Icon";
import { InterviewItem } from "@/fetch/suppliers";
import { useOpenExternalURL, useTrackers } from "@/hooks";
import { useTripPlacementsQuery } from "@/fetch/trip";
import styles from "./OfferedJob.module.scss";

type Props = {
  matchInterview: InterviewItem;
};

const OfferedJob: FC<Props> = ({ matchInterview }) => {
  const openExternalURL = useOpenExternalURL();
  const { track } = useTrackers();

  const { data: tripPlacementsData, isLoading: isLoadingTrpPlacements } =
    useTripPlacementsQuery();

  const redirectToWebsite = () => {
    const webSiteUrl = matchInterview.website || "";
    openExternalURL(webSiteUrl);
    track("Job Link Viewed", { eventId: "job-link-viewed", link: webSiteUrl });
  };

  const getPlacementDate = () => {
    const tripPlacements = tripPlacementsData?.result || [];
    const relatedTripPlacement = tripPlacements.find(
      (each) => each.interview_id === matchInterview.id
    );
    if (relatedTripPlacement) {
      return dayjs(Number(relatedTripPlacement?.start_date) * 1000).format(
        "D MMMM YYYY"
      );
    }
    return "N/A";
  };

  return (
    <Card className={styles.details}>
      <Grid
        container
        spacing="0px"
        columnSpacing="0px"
        rowSpacing="16px"
        className={styles.dateRow}
      >
        <Grid
          container
          spacing="0px"
          columnSpacing="0px"
          rowSpacing="16px"
          className={styles.dateRow}
        >
          <Grid item md={3} xs={12}>
            <MiniTable header="Position" value={matchInterview.role || ""} />
          </Grid>
          <Grid item md={9} xs={12}>
            <MiniTable
              header="Company"
              value={matchInterview.partner_name || ""}
            />
          </Grid>
        </Grid>
        <Grid item md={3} xs={6}>
          <MiniTable header="Start Date" value={getPlacementDate()} />
        </Grid>
        <Grid item md={3} xs={6}>
          <MiniTable
            header="Contact Person"
            value={matchInterview.interviewer || ""}
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <MiniTable
            header="Website"
            value={
              <span>
                {Boolean(matchInterview.website) && (
                  <span>
                    {matchInterview.website || ""}
                    <RedirectIcon
                      onClick={redirectToWebsite}
                      className={styles.websiteRedirectIcon}
                    />
                  </span>
                )}
              </span>
            }
          />
        </Grid>
        <Grid item md={12} xs={12}>
          <MiniTable
            header="Location"
            value={
              <span>
                {matchInterview.address}
                <br />
                {matchInterview.phone}
              </span>
            }
          />
        </Grid>
      </Grid>
    </Card>
  );
};

export default OfferedJob;
